const LAYOUT_TYPES = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal",
  TWOCOLUMN: "twocolumn",
}

const LAYOUT_MODE_TYPES = {
  LIGHTMODE: "light",
  DARKMODE: "dark",
}

const LAYOUT_THEME_TYPES = {
  DEFAULT: "default",
  MATERIAL: "material",
  CREATIVE: "creative",
  MINIMAL: "minimal",
  MODERN: "modern",
  INTERACTION: "interaction",
}

const LAYOUT_WIDTH_TYPES = {
  FLUID: "fluid",
  SCROLLABLE: "scrollable",
}

const LAYOUT_POSITION_TYPES = {
  FIXED: "fixed",
  BOXED: "boxed"
}

const LAYOUT_TOPBAR_COLOR_TYPES = {
  LIGHT: "light",
  DARK: "dark",
}

const LEFT_SIDEBAR_SIZE = {
  DEFAULT: "lg",
  COMPACT: "md",
  SMALL: "sm",
  SMALL_HOVER: "sm-hover",
}

const LEFT_SIDEBAR_VIEW = {
  DEFAULT: "default",
  DETACHED: "detached",
}

const DATA_SIDEBAR_COLOR = {
  LIGHT: "light",
  DARK: "dark",
  GRADIANT: "gradient",
  GRADIANT2: "gradient-2",
  GRADIANT3: "gradient-3",
  GRADIANT4: "gradient-4",
}


const DATA_SIDEBAR_IMAGE = {
  ONE: "img-1",
  TWO: "img-2",
  THREE: "img-3",
  FOUR: "img-4",
  NONE: "none",
};

const PERLOADER_TYPES = {
  ENABLE: "enable",
  DISABLE: "disable"
};


export {
  LAYOUT_TYPES,
  LAYOUT_MODE_TYPES, LAYOUT_THEME_TYPES,
  DATA_SIDEBAR_COLOR,
  LEFT_SIDEBAR_SIZE,
  DATA_SIDEBAR_IMAGE,
  LAYOUT_WIDTH_TYPES,
  LAYOUT_POSITION_TYPES,
  LAYOUT_TOPBAR_COLOR_TYPES,
  LEFT_SIDEBAR_VIEW,
  PERLOADER_TYPES
}